// ** Polyfills
import ResizeObserver from "resize-observer-polyfill";

export class EditorResizeObserver {
	constructor() {
		this._observer = new ResizeObserver(this.handler.bind(this));
		this._observers = new WeakMap();
	}

	handler(entries) {
		for (const entry of entries) {
			const callback = this._observers.get(entry.target);

			if (typeof callback === "function") {
				callback(entry);
			}
		}
	}

	observe(reference, onObserve) {
		if (reference.current === null || reference.current === undefined) {
			return false;
		}

		this.unobserve(reference);
		this._observers.set(reference.current, onObserve);
		this._observer.observe(reference.current);
	}

	unobserve(reference) {
		if (reference.current === null) {
			return false;
		}

		this._observers.delete(reference.current);
		this._observer.unobserve(reference.current);

		return true;
	}

	clear() {
		this._observer.disconnect();
	}
}
